import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Format a number to max 2 decimal places, German locale */
export function fmt2(value) {
  if (value == null || isNaN(value)) return '-';
  return Number(value).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Format EUR value from kEUR to EUR with 2 decimals */
export function fmtEUR(kEUR) {
  if (kEUR == null || isNaN(kEUR)) return '-';
  return fmt2(kEUR * 1000);
}

/** Calculate price per unit */
export function pricePerUnit(totalEUR, quantity) {
  if (!totalEUR || !quantity || quantity === 0) return null;
  return totalEUR / quantity;
}

/** Calculate running meters (Laufmeter) from m² and width.
 *  Only applies when UoM is m²/qm/sqm.
 *  Formula: Laufmeter = m² / (width_mm / 1000)
 */
export function calcLaufmeter(quantitySqm, widthMm) {
  if (!quantitySqm || !widthMm || widthMm === 0) return null;
  return quantitySqm / (widthMm / 1000);
}

/** Check if a UoM represents square meters */
export function isSqmUnit(uom) {
  if (!uom) return false;
  const normalized = uom.toLowerCase().trim();
  return ['m²', 'qm', 'sqm', 'm2', 'quadratmeter'].includes(normalized);
}
